import { FC } from 'react';
import { COLORS } from '@connect-x-app/shared-ui';
import classNames from 'classnames';

import { Text } from '../Text/Text';
import { DotProps, DotSize } from './Dot.shared';

import './Dot.scss';

const SIZE_CLASS_MAP: Record<DotSize, string> = {
  l: 'large',
  m: 'medium',
  s: 'small',
  xs: 'extra-small',
  xxs: 'extra-extra-small',
};

export const Dot: FC<DotProps> = ({ className, fontSize = 'SM', size = 's', testId, type = 'primary', value }) => {
  const sizeClass = SIZE_CLASS_MAP[size];

  return (
    <span className={classNames('dot-container', sizeClass, className, `dot--${type}`)} data-test={testId}>
      {value ? (
        <Text as="span" color={COLORS.zulu.$10} size={fontSize} weight="bold">
          {value}
        </Text>
      ) : null}
    </span>
  );
};
